import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center bg-white border border-[#E7E5E4] rounded-lg p-10">
        <XCircle className="h-14 w-14 mx-auto text-[#7C1F30] mb-6" />
        <h1 className="font-serif text-3xl mb-3">Payment cancelled</h1>
        <p className="text-sm text-[#78716C] mb-6">
          No worries — your cart is still saved. Try again whenever you're ready.
        </p>
        <Link
          to="/cart"
          data-testid="cancel-back-cart"
          className="inline-block bg-[#7C1F30] hover:bg-[#8D2A3D] text-white px-6 py-3 rounded-full uppercase text-xs tracking-[0.2em]"
        >
          Back to Cart
        </Link>
      </div>
    </div>
  );
}
